<template>
  <div>
    <!-- 顶部导航栏，复用Dashboard样式 -->
    <header class="dashboard-header-bar">
      <div class="dashboard-header-container">
        <div @click="goToHome" class="logo" style="cursor: pointer;">
          <img src="/logo.png" alt="Linkoffer Logo" class="logo-icon" width="32" height="32">
          <span>Linkoffer</span>
        </div>
        <div class="dashboard-actions">
          <!-- <div @click="goToUserCenter" class="icon-btn user-btn" title="用户中心" style="cursor: pointer;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke="#1890ff" stroke-width="2"/><path d="M4 20c0-2.5 3.5-4.5 8-4.5s8 2 8 4.5" stroke="#1890ff" stroke-width="2" stroke-linecap="round"/></svg>
          </div> -->
          <div @click="goToHome" class="icon-btn home-btn" title="返回主页" style="cursor: pointer;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 12l9-8 9 8" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 21V12h6v9" stroke="#1890ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
      </div>
    </header>

    <div class="user-center-page">
      <div class="card user-info-card">
        <div class="user-info-header">用户信息</div>
        <div class="user-info-content">
          <div class="user-avatar-block">
            <div class="user-avatar">
              <iconify-icon icon="tabler:user" width="48" height="48" />
            </div>
          </div>
          <div class="user-info-list">
            <div class="user-info-item">手机号：{{ userInfo.phone }}</div>
            <div class="user-info-item">邮箱：{{ userInfo.email }}</div>
            <div class="user-info-item">我的邀请码：{{ userInfo.inviteCode }} <span class="copy-icon" @click="copy">📋</span></div>
          </div>
          <div class="user-info-actions">
            <button class="btn-blue" @click="logout">退出登录</button>
            <button class="btn-blue" @click="deleteAccount">账号注销</button>
          </div>
        </div>
      </div>

      <div class="card balance-card">
        <div class="balance-row">
          <div class="balance-block">
            <div class="balance-title-row">
              <div class="balance-title">可用面试币</div>
              <a class="link" href="#" @click="viewPurchaseRecords">充值记录 &gt;</a>
            </div>
            <div class="balance-value">{{ userInfo.balance }}</div>
            <div class="balance-desc">预计可面试 {{ Math.floor(userInfo.balance / 1) }} 分钟</div>
            <div class="balance-desc">预计可进行AI快答 {{ Math.floor(userInfo.balance/3) }} 次</div>
            <div class="balance-actions">
              <button class="btn-blue" @click="recharge">充值</button>
              <!-- <button class="btn-blue" @click="withdraw">提现</button> -->
            </div>
          </div>
          <div class="balance-block">
            <div class="balance-title-row">
              <div class="balance-title">邀请人数</div>
              <a class="link" href="#" @click="viewInvitationRecords">邀请记录 &gt;</a>
            </div>
            <div class="balance-value">{{ userInfo.inviteeCount }}</div>
            <div class="balance-desc">已奖励面试币 {{ userInfo.inviteeCount * 10 }}</div>
            <div class="balance-actions" style="margin-top: 32px;">
              <button class="btn-blue" @click="goInvite">去邀请</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card setting-card">
        <div class="setting-header">面试设置</div>
        <div class="setting-content">
          
          <div class="setting-row">
            <label class="setting-label">快答快捷键</label>
            <div class="shortcut-input-container">
               <el-input v-model="fastAnswerShortcut" disabled :placeholder="isMac ? 'option+P' : 'Alt+P'"></el-input>
            </div>
          </div>
          <div class="setting-row">
            <label class="setting-label">深度回答快捷键</label>
            <div class="shortcut-input-container">
               <el-input v-model="deepAnswerShortcut" disabled :placeholder="isMac ? 'option+O' : 'Alt+O'"></el-input>
            </div>
          </div>
          <div class="setting-row">
            <label class="setting-label">截图快捷键</label>
            <div class="shortcut-input-container">
               <el-input v-model="captureShortcut" disabled :placeholder="isMac ? 'option+I' : 'Alt+I'"></el-input>
            </div>
          </div>
          <!-- <div class="setting-row">
            <label class="setting-label">语音触发快答</label>
            <span class="setting-switch">
              <span class="custom-switch" :class="{ checked: form.voiceTrigger }" @click="toggleVoiceTrigger">
                <span class="switch-circle"></span>
              </span>
            </span>
          </div>
          <div class="setting-row">
            <label class="setting-label">触发关键词</label>
            <div class="shortcut-input-container">
               <el-input v-model="form.voiceTriggerWords" disabled placeholder="请输入触发关键词"></el-input>
            </div>
            
           </div> -->
          <div class="setting-actions">
            <button class="btn-blue" @click="updateUserSave">保存</button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
    title="记录"
    width="40%"
    v-model="dialogPurchaseVisible"
    :close-on-click-modal="false"
     append-to-body
    > 
      <div class="content" style="height: 600px;">
        <!-- 内容区域 -->
        <Purchase
            :dialogPurchaseVisible="dialogPurchaseVisible"
            @close="dialogPurchaseVisible = false"
          ></Purchase> 
      </div>
            
    </el-dialog>

      <!-- 登录dialog -->

    <el-dialog
     style="margin-top: 150px"
      title=""
      width="30%"
      v-model="dialogInviVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <InvitationDialog
          :dialogInviVisible="dialogInviVisible"
          @close="dialogInviVisible = false"
          :invitationCode="invitationCode"
          @loginSuccess="loginSuccess"
      ></InvitationDialog>
    </el-dialog>


    <el-dialog
      title="邀请记录"
      width="40%"
      v-model="dialogInvitationVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="content">
        <InvitationRecordsDialog
        v-if="dialogInvitationVisible"
        
        @close="dialogInvitationVisible = false"
        ></InvitationRecordsDialog>
      </div>
    </el-dialog>

     <!-- 退款dialog -->
    <RefundDialog ref="refundDialog" @refresh-balance="getUserInfo"></RefundDialog>
    <!-- 引入支付弹窗组件 -->
    <PaymentModal ref="paymentModal"></PaymentModal>

    <!-- 账号注销确认弹窗 -->
    <el-dialog
      title=""
      width="400px"
      v-model="dialogDeleteVisible"
      :close-on-click-modal="false"
      append-to-body
      dialog-class="custom-dialog-radius"
    >
      <div class="delete-container">
        <!-- 标题 -->
        <div class="dialog-title">账号注销确认</div>
        
        <!-- 警告信息 -->
        <!-- <div class="warning-content">
          <div class="warning-icon">⚠️</div>
          <div class="warning-text">
            <p>注销账号后，以下数据将被永久删除：</p>
            <ul>
              <li>• 个人资料信息</li>
              <li>• 面试币余额</li>
              <li>• 面试记录</li>
              <li>• 邀请记录</li>
            </ul>
            <p class="warning-tip">此操作不可恢复，请谨慎操作！</p>
          </div>
        </div> -->

        <!-- 手机号验证 -->
        <div class="phone-verification">
          <div class="input-box phone-input">
            <span class="country-code">+86</span>
            <el-input v-model="deleteForm.phone" placeholder="请输入手机号码" maxlength="11" type="tel"></el-input>
          </div>
        </div>

        <!-- 验证码 -->
        <div class="code-verification">
          <div class="input-box code-input">
            <span class="code-label">验证码</span>
            <el-input v-model="deleteForm.code" placeholder="请输入" maxlength="6"></el-input>
            <el-button type="primary" class="get-code-btn" @click="handleGetDeleteCode" :disabled="deleteCountdown > 0">
              <span>{{ deleteCountdown > 0 ? `重新发送(${deleteCountdown}s)` : '获取验证码' }}</span>
            </el-button>
          </div>
        </div>

        <!-- 按钮容器 -->
        <div class="button-container">
          <el-button 
            class="cancel-btn" 
            @click="dialogDeleteVisible = false"
          >
            取消
          </el-button>
          <el-button 
            type="danger" 
            class="confirm-delete-btn"
            @click="handleDeleteAccount"
            :disabled="!deleteForm.phone || !deleteForm.code"
          >
            确认注销
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>



<script>
import Purchase from './PurchaseRecordsDialog.vue';
import InvitationRecordsDialog from './InvitationRecordsDialog.vue';
import InvitationDialog from './InvitationDialog.vue';
import RefundDialog from './RefundDialog.vue';
import PaymentModal from '@/views/HomepageMenu/PaymentModal.vue';

import { getUserInfo, updateUser, code, deactivate } from "@/api/login/login";
import { isMacOS, getShortcutText } from "@/utils/common";

import { useStore } from "@/store";

export default {
     components: {
    'Purchase': Purchase,
     'InvitationDialog': InvitationDialog,
     'RefundDialog': RefundDialog,
     PaymentModal,
     'InvitationRecordsDialog': InvitationRecordsDialog 
    
  },
  data() {
    return {
      
      userInfo: {
        phone: '',
        email: '',
        inviteCode: '',
        balance: 0,
        inviteeCount: 0
      },
      form: {
        voiceTrigger: false, // 是否开启语音触发
        voiceTriggerWords: '',  //语音触发词列表(逗号隔开)
        shortcutConfig: ''
      },
      captureShortcut: getShortcutText('I'),
      fastAnswerShortcut: getShortcutText('P'),
      deepAnswerShortcut: getShortcutText('O'),
      
      // 弹窗标识
      dialogPurchaseVisible: false,
      dialogInvitationVisible: false, // 新增这一行
      // 弹窗标识
      dialogInviVisible: false,
      dialogDeleteVisible: false, // 账号注销弹窗
      deleteForm: {
        phone: '', // 手机号
        code: '' // 验证码
      },
      deleteCountdown: 0, // 注销验证码倒计时
      availableCoins: 50,
      estimatedInterviewTime: 5,
      estimatedInterviewSeconds: 10,
      estimatedAIFastAnswers: 5,
      invitedUsers: 5,
      rewardedCoins: 50,
      enableVoiceTrigger: true,
      triggerKeywords: '我想一下,给我一分钟可以吗',
      invitationCode: ''
    };
  },
  created() {
    this.store = useStore();
    this.getUserInfo();
  },
  computed: {
    maskedphone() {
      return this.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    isMac() {
      return isMacOS();
    }
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
       // 准备登录信息
      const obj = Object.assign({}, this.form);
      const response = await getUserInfo(obj)
      if (response.code === 200) {
         //  缓存当前登录用户信息
         this.userInfo = response.data;
         this.store.userInfo = response.data;
         this.form = response.data.extraData;
         this.invitationCode = response.data.inviteCode;
        }
    },
    logout() {
      console.log('退出登录');
      this.store = useStore();
      this.store.isLogin = false;
      //  清除token
      this.store.token =""
      //  清除刷新token
      this.store.refreshToken = ""
      this.goToHome();
    },
         // 跳转首页
    goToHome() {
      this.$router.push('/home');
    },
    deleteAccount() {
      console.log('账号注销');
      this.dialogDeleteVisible = true;
    },
    // 开始捕获快捷键
    startCaptureShortcut() {
      this.$refs.shortcutInput.focus();
      this.$message.info('请按下您想要设置的快捷键组合');
    },
    
    // 捕获快捷键
    handleCaptureShortcut(event) {
      event.preventDefault();
      
      const keys = [];
      
      // 检查修饰键
      if (event.ctrlKey) keys.push('Ctrl');
      if (event.shiftKey) keys.push('Shift');
      if (event.altKey) keys.push('Alt');
      if (event.metaKey) keys.push('Meta');
      
      // 获取主键
      const key = event.key.toUpperCase();
      if (key !== 'CONTROL' && key !== 'SHIFT' && key !== 'ALT' && key !== 'META') {
        keys.push(key);
      }
      
      if (keys.length > 0) {
        this.form.shortcutConfig = keys.join('+');
        this.$message.success(`快捷键已设置为: ${this.form.shortcutConfig}`);
      }
    },
    
    // 清除快捷键
    clearShortcut() {
      this.form.shortcutConfig = '';
      this.$message.success('快捷键已清除');
    },
    
    // 切换语音触发开关
    toggleVoiceTrigger() {
      this.form.voiceTrigger = !this.form.voiceTrigger;
      if (!this.form.voiceTrigger) {
        this.form.voiceTriggerWords = '';
      }
    },
    
    updateUserSave() {
      console.log('保存设置');
      const obj = Object.assign({}, this.form);
      updateUser(obj).then(response => {
        if (response.code === 200) {
          this.$message.success('设置保存成功');
          this.getUserInfo(); // 更新用户信息
        } else {
          this.$message.error(response.message);
        }
      });
    },
    copy() {
      const email = this.userInfo.inviteCode;
      navigator.clipboard.writeText(email).then(() => {
        this.$message.success('已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    recharge() {
      console.log('充值');
      this.$router.push({
        name: 'home',
        query: { activeIndex: 3}
      });
    },
    withdraw() {
      console.log('退款');
      this.$refs.refundDialog.show();
    },
    viewPurchaseRecords() {
      console.log('查看购买记录');
      this.dialogPurchaseVisible = true;
    },
    viewInvitationRecords() {
      console.log('查看邀请记录');
      this.dialogInvitationVisible = true; // 修改这一行
    },
    goInvite() {
      console.log('去邀请');
      this.dialogInviVisible = true;
    },
    loginSuccess(val) {
      console.log('登录成功:', val);
    },
    goToUserCenter() {
      this.$router.push('/user-center');
    },
    
    // 处理获取注销验证码
    async handleGetDeleteCode() {
      if (this.deleteCountdown > 0) return;
      
      if (!this.deleteForm.phone) {
        this.$message.error('请先输入手机号码');
        return;
      }
      
      // 准备验证码请求信息
      const obj = {
        phone: this.deleteForm.phone,
        scene: 'deactivate' // 注销场景
      };
      
      try {
        const response = await code(obj);
        if (response.code === 200) {
          this.$notify({ 
            title: '成功', 
            message: '验证码已发送', 
            type: 'success', 
            duration: 2000 
          });
          // 启动倒计时
          this.deleteCountdown = 60;
          const timer = setInterval(() => {
            if (this.deleteCountdown <= 0) {
              clearInterval(timer);
            } else {
              this.deleteCountdown--;
            }
          }, 1000);
        } else {
          this.$alert(response.message, '提示', { type: 'warning' });
        }
      } catch (error) {
        console.error('获取验证码失败:', error);
        this.$message.error('获取验证码失败，请重试');
      }
    },
    
    // 处理账号注销
    handleDeleteAccount() {
      if (!this.deleteForm.phone || !this.deleteForm.code) {
        this.$message.error('请填写手机号和验证码');
        return;
      }
      
      // 这里应该调用注销API
      console.log('执行账号注销操作');
      this.$confirm('确定要注销账号吗？此操作不可恢复！', '最终确认', {
        confirmButtonText: '确定注销',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'el-button--danger'
      }).then(() => {
        // 执行注销逻辑
        this.performAccountDeletion();
      }).catch(() => {
        this.$message.info('已取消注销');
      });
    },
    
    // 执行账号删除
    performAccountDeletion() {
      console.log('正在删除账号...');
      const obj = {
        phone: this.deleteForm.phone,
        code: this.deleteForm.code
      };
      
      deactivate(obj, this.deleteForm.code).then(response => {
        if (response.code === 200) {
          this.$message.success('账号注销成功');
          this.dialogDeleteVisible = false;
          this.deleteForm.phone = '';
          this.deleteForm.code = '';
          this.deleteCountdown = 0;
          
          // 清除用户数据并跳转到首页
          this.store.isLogin = false;
          this.store.token = '';
          this.store.refreshToken = '';
          this.store.userInfo = {};
          this.$router.push('/home');
        } else {
          this.$message.error(response.message || '账号注销失败');
        }
      }).catch(error => {
        console.error('账号注销失败:', error);
        this.$message.error('账号注销失败，请重试');
      });
    }
  }
};
</script>

<style scoped>
/* 顶部导航栏样式，复用dashboard */
.dashboard-header-bar {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  position: sticky;
  top: 0;
  z-index: 100;
}
.dashboard-header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-weight: 600;
  font-size: 20px;
}
.logo-icon {
  height: 32px;
  width: 32px;
  margin-right: 8px;
}
.dashboard-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}
.icon-btn {
  background: #fff;
  border: 1.5px solid #1890ff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  padding: 0;
}
.icon-btn:hover {
  background: #e6f7ff;
  border-color: #1765ad;
}
.user-btn svg, .home-btn svg {
  display: block;
  width: 20px;
  height: 20px;
}

/* Switch样式 */
.custom-switch {
  display: inline-block;
  width: 40px;
  height: 22px;
  background: #e5e6eb;
  border-radius: 11px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  vertical-align: middle;
}
.custom-switch.checked {
  background: #1890ff;
}
.switch-circle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.custom-switch.checked .switch-circle {
  left: 20px;
}
.setting-input.disabled {
  background: #f5f5f5;
  color: #bfbfbf;
  cursor: not-allowed;
}
.user-center-page {
  padding: 24px 0 32px 0;
  max-width: 900px;
  margin: 0 auto;
}
.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-bottom: 24px;
  padding: 20px 24px;
}
.user-info-header,
.setting-header {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #1f2329;
}
.user-info-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.user-avatar-block {
  flex: none;
  margin-right: 24px;
}
.user-avatar {
  width: 48px;
  height: 48px;
  background: #f0f2f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #4e5969;
  margin-bottom: 8px;
}
.user-info-list {
  flex: 1;
  min-width: 220px;
}
.user-info-item {
  font-size: 14px;
  color: #1f2329;
  margin-bottom: 6px;
}
.copy-icon {
  font-size: 14px;
  margin-left: 4px;
  cursor: pointer;
}
.user-info-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: 32px;
}
.btn-blue {
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 18px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-blue:hover {
  background: #40a9ff;
}
.balance-card {
  padding: 0;
}
.balance-row {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  position: relative;
}
.balance-block {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f0f2f5;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}
.balance-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}
.balance-title {
  font-size: 14px;
  color: #1f2329;
  font-weight: 500;
}
.balance-value {
  font-size: 22px;
  color: #1890ff;
  font-weight: bold;
  margin-bottom: 6px;
}
.balance-desc {
  font-size: 13px;
  color: #86909c;
  margin-bottom: 4px;
}
.balance-actions {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}
.link {
  color: #1890ff;
  font-size: 13px;
  text-decoration: none;
  transition: color 0.2s;
  margin-left: 16px;
}
.link:hover {
  color: #40a9ff;
}
.setting-card {
  margin-top: 24px;
}
.setting-content {
  background: #fafbfc;
  border-radius: 8px;
  padding: 20px 24px;
  margin-left: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.setting-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  width: 100%;
}
.setting-label {
  width: 120px;
  font-size: 15px;
  color: #4e5969;
  flex-shrink: 0;
  text-align: left;
  font-weight: 500;
}
.setting-input {
  flex: 1;
  padding: 10px 8px;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  font-size: 15px;
  color: #1f2329;
  background: #fff;
  margin-left: 4px;
  box-sizing: border-box;
}
.setting-switch {
  margin-left: 4px;
  display: flex;
  align-items: center;
}
.setting-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  width: 100%;
}

/* 快捷键输入框样式 */
.shortcut-input-container {
  display: flex;
  align-items: center;
  flex: 1;
  margin-left: 4px;
}

.shortcut-input {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px 12px;
  min-height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: #fff;
  transition: all 0.3s;
  user-select: none;
  color: #606266;
  flex: 1;
}

.shortcut-input:hover {
  border-color: #c0c4cc;
}

.shortcut-input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.shortcut-input:empty::before {
  content: '点击设置快捷键';
  color: #c0c4cc;
}

.btn-clear {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 10px;
}

.btn-clear:hover {
  background: #e6e6e6;
  border-color: #c0c4cc;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .user-info-container {
    padding: 16px;
  }
  
  .user-info-header {
    margin-bottom: 20px;
  }
  
  .user-info-title {
    font-size: 1.5rem;
  }
  
  .user-info-subtitle {
    font-size: 0.9rem;
  }
  
  .setting-section {
    margin-bottom: 24px;
  }
  
  .setting-section h3 {
    font-size: 1.2rem;
    margin-bottom: 16px;
  }
  
  .setting-row {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
  }
  
  .setting-label {
    width: 100%;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .setting-input {
    width: 100%;
    margin-left: 0;
    padding: 12px 10px;
    font-size: 14px;
  }
  
  .shortcut-input-container {
    width: 100%;
    margin-left: 0;
  }
  
  .shortcut-input {
    padding: 12px 10px;
    font-size: 14px;
    min-height: 44px;
  }
  
  .btn-clear {
    margin-left: 8px;
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .setting-actions {
    margin-top: 16px;
  }
  
  .setting-actions button {
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .user-info-container {
    padding: 20px;
  }
  
  .user-info-title {
    font-size: 1.8rem;
  }
  
  .setting-section h3 {
    font-size: 1.3rem;
  }
  
  .setting-label {
    font-size: 15px;
  }
  
  .setting-input {
    padding: 12px 10px;
    font-size: 15px;
  }
  
  .shortcut-input {
    padding: 10px 12px;
    font-size: 15px;
  }
  
  .btn-clear {
    font-size: 13px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .user-info-container {
    padding: 12px;
  }
  
  .user-info-header {
    margin-bottom: 16px;
  }
  
  .user-info-title {
    font-size: 1.3rem;
  }
  
  .user-info-subtitle {
    font-size: 0.8rem;
  }
  
  .setting-section {
    margin-bottom: 20px;
  }
  
  .setting-section h3 {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }
  
  .setting-row {
    margin-bottom: 12px;
  }
  
  .setting-label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .setting-input {
    padding: 10px 8px;
    font-size: 13px;
  }
  
  .shortcut-input {
    padding: 10px 8px;
    font-size: 13px;
    min-height: 40px;
  }
  
  .btn-clear {
    margin-left: 6px;
    padding: 6px 10px;
    font-size: 12px;
  }
  
  .setting-actions {
    margin-top: 12px;
  }
  
  .setting-actions button {
    padding: 10px 16px;
    font-size: 15px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .user-info-container {
    padding: 16px;
  }
  
  .user-info-header {
    margin-bottom: 16px;
  }
  
  .user-info-title {
    font-size: 1.4rem;
  }
  
  .setting-section {
    margin-bottom: 20px;
  }
  
  .setting-section h3 {
    font-size: 1.2rem;
    margin-bottom: 12px;
  }
  
  .setting-row {
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
  }
  
  .setting-label {
    width: 100px;
    margin-bottom: 0;
    font-size: 13px;
  }
  
  .setting-input {
    width: auto;
    margin-left: 4px;
    padding: 8px 10px;
    font-size: 13px;
  }
  
  .shortcut-input-container {
    width: auto;
    margin-left: 4px;
  }
  
  .shortcut-input {
    padding: 8px 10px;
    font-size: 13px;
    min-height: 36px;
  }
  
  .btn-clear {
    margin-left: 6px;
    padding: 6px 10px;
    font-size: 12px;
  }
  
  .setting-actions {
    margin-top: 12px;
  }
  
  .setting-actions button {
    width: auto;
    padding: 8px 16px;
    font-size: 14px;
  }
}

/* 账号注销弹窗样式，参照登录页面 */
.delete-container {
  padding: 0px 8px 8px 8px;
}

.dialog-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #1f2329;
}

.warning-content {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 16px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 6px;
}

.warning-icon {
  font-size: 24px;
  margin-right: 12px;
  margin-top: 2px;
}

.warning-text {
  flex: 1;
}

.warning-text p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #1f2329;
  line-height: 1.5;
}

.warning-text ul {
  margin: 8px 0;
  padding-left: 16px;
}

.warning-text li {
  font-size: 14px;
  color: #1f2329;
  margin-bottom: 4px;
  line-height: 1.4;
}

.warning-tip {
  color: #ff4d4f !important;
  font-weight: 500;
  margin-top: 8px !important;
}

/* 手机号验证和验证码输入样式，参照登录页面 */
.phone-verification,
.code-verification {
  margin-bottom: 16px;
}

/* 统一输入容器：与 LoginPage 风格对齐 */
.input-box {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  height: 40px;
  width: 100%;
}

.input-box :deep(.el-input__wrapper) {
  box-shadow: none !important;
}

.input-box :deep(.el-input__inner) {
  height: 40px;
}

.input-box .el-input {
  flex: 1;
}

/* 左侧标签/区号，统一宽度，右侧竖边界对齐 */
.country-code,
.code-label {
  box-sizing: border-box;
  width: 76px;
  padding: 0 12px;
  border-right: 1px solid #ddd;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
}

/* 手机号输入：区号文本样式 */
.country-code {
  color: #333;
  font-size: 14px;
  background-color: #fff;
}

/* 验证码输入：左侧标签文本样式 */
.code-label {
  color: #666;
  font-size: 14px;
}

/* 验证码按钮固定宽度 */
.get-code-btn {
  min-width: 110px;
  padding: 0 12px;
  height: 100%;
  background-color: transparent;
  border: none;
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
  border-left: 1px solid #ddd;
  white-space: nowrap;
}

.get-code-btn.is-disabled,
.get-code-btn:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.get-code-btn:hover:not(.is-disabled) {
  background-color: #f8f9fa;
}

/* 按钮容器 */
.button-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 12px !important;
  margin-top: 20px !important;
  position: relative !important;
}

.cancel-btn {
  width: 80px;
  height: 40px;
  border-radius: 8px;
  background: #f5f5f5;
  color: #666;
  font-size: 14px;
  border: 1px solid #d9d9d9;
}

.cancel-btn:hover {
  background: #e6e6e6;
  border-color: #c0c4cc;
}

.confirm-delete-btn {
  width: 100px;
  height: 40px;
  border-radius: 8px;
  background: #ff4d4f;
  color: #fff;
  font-size: 14px;
  border: none;
}

.confirm-delete-btn:hover:not(:disabled) {
  background: #ff7875;
}

.confirm-delete-btn:disabled {
  background: #d9d9d9;
  color: #bfbfbf;
  cursor: not-allowed;
}

/* 弹窗圆角 */
.custom-dialog-radius .el-dialog__body {
  border-radius: 10px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .el-dialog {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2.5vw auto !important;
  }
  
  .delete-container {
    padding: 20px 16px;
  }
  
  .dialog-title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  
  .warning-content {
    padding: 12px;
    margin-bottom: 16px;
  }
  
  .warning-text p,
  .warning-text li {
    font-size: 13px;
  }
  
  .input-box :deep(.el-input__inner) {
    height: 40px;
    font-size: 14px;
  }
  
  .button-container {
    flex-direction: column !important;
    gap: 12px !important;
    margin-top: 20px !important;
  }
  
  .cancel-btn,
  .confirm-delete-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-dialog {
    width: 80vw !important;
    max-width: 80vw !important;
  }
  
  .delete-container {
    padding: 24px 20px;
  }
  
  .dialog-title {
    font-size: 1.6rem;
  }
  
  .input-box :deep(.el-input__inner) {
    height: 42px;
    font-size: 15px;
  }
  
  .cancel-btn,
  .confirm-delete-btn {
    height: 42px;
    font-size: 15px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .el-dialog {
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vw auto !important;
  }
  
  .delete-container {
    padding: 16px 12px;
  }
  
  .dialog-title {
    font-size: 1.3rem;
    margin-bottom: 16px;
  }
  
  .warning-content {
    padding: 10px;
    margin-bottom: 12px;
  }
  
  .warning-text p,
  .warning-text li {
    font-size: 12px;
  }
  
  .input-box :deep(.el-input__inner) {
    height: 38px;
    font-size: 13px;
  }
  
  .cancel-btn,
  .confirm-delete-btn {
    height: 40px;
    font-size: 15px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .el-dialog {
    width: 90vw !important;
    max-width: 90vw !important;
    max-height: 90vh !important;
    overflow-y: auto;
  }
  
  .delete-container {
    padding: 20px 16px;
  }
  
  .button-container {
    flex-direction: row !important;
    gap: 12px !important;
  }
  
  .cancel-btn,
  .confirm-delete-btn {
    width: auto;
    height: 38px;
    font-size: 14px;
  }
}
</style>